<template>
  <view>
    <div class="test">
      <load-refresh
        ref="loadRefresh"
        :is-refresh="true"
        :refresh-time="400"
        :height-reduce="0"
        :background-cover="'#F3F5F5'"
        :page-no="currPage"
        :total-page-no="totalPage" 
        @loadMore="loadMore" 
        @refresh="refresh"
      >
        <view slot="content-list">
          <ul class="list">
            <li
              v-for="(item,index) in list"
              :key="index"
            >
              {{ item }}
            </li>
          </ul>
          <!-- 数据列表 -->
        </view>
      </load-refresh>
      <!-- <canvas
        canvas-id="firstCanvas"
      />
      <section class="hero">
        <div class="text">
          <h1>Canvas Rain</h1>
          <p>Oh yeah. It's raining.</p>
        </div>
      </section> -->
      
      <!-- animate__animated animate__fadeInUp
      <!-- <view
        class="yellow"
        :animation="animationData2"
      />
      <div
        class="button"
        @click="animationClick"
      >
        button
      </div>
      <view
        class="contain"
        :animation="animationData"
      /> -->
    </div>
  </view>
</template>

<script>
import loadRefresh from '@/components/load-refresh/load-refresh.vue';
export default {
	components:{
		loadRefresh
	},
	data(){
		return{
			show:false,
			animationData:{},
			animationData2:{},
			state:false,
			list:[1,2,3,4,5,6,78,9,0,0,1,3,3,4],
			currPage:1,
			totalPage:10
		};
	},
	onLoad(e) {
		let a = '111';
		this.animation = uni.createAnimation({
			timingFunction: 'ease',
		});
	},
	onReady() {
		var ctx = uni.createCanvasContext('firstCanvas');
		
		var w = 500;
		var h = 1334;
		// for(var i=0;i<10;i++){
		// ctx.beginPath()
		// ctx.moveTo(10*i,10)
		// ctx.lineTo(10*i,50)
		// ctx.stroke()
		// }
		
		// ctx.draw()
		var init = [];
		
		var maxParts = 300;
		for(var a = 0; a < maxParts; a++) {
		  init.push({
		    x: Math.random() * w,
		    y: Math.random() * h,
		    l: Math.random() * 1,
		    xs: -4 + Math.random() * 4 + 2,
		    ys: Math.random() * 10 + 10
		  });
		}
		
		var particles = [];
		for(var b = 0; b < maxParts; b++) {
		  particles[b] = init[b];
		}
		
		function draw() {
		  ctx.clearRect(0, 0, w, h);
		  for(var c = 0; c < particles.length; c++) {
		    var p = particles[c];
			ctx.setStrokeStyle('rgba(255,255,255,0.4)');
			ctx.setLineWidth(1);
			ctx.setLineCap('round');
		    ctx.beginPath();
		    ctx.moveTo(p.x, p.y);
		    ctx.lineTo(p.x + p.l * p.xs, p.y + p.l * p.ys);
		    ctx.stroke();
		  }
		  move();
		}
		function move() {
		  for(var b = 0; b < particles.length; b++) {
		    var p = particles[b];
		    p.x += p.xs;
		    p.y += p.ys;
		    if(p.x > w || p.y > h) {
		      p.x = Math.random() * w;
		      p.y = -20;
		    }
		  }
		  ctx.draw();
		}
		draw();
		setInterval(draw, 60);
	},
	mounted() {
		let a ='111';
		// this.$uma.trackEvent('pageClick',{
		// 	url:this.$mp.page.route,
		// 	title:'测试页'
		// })
	},
	methods:{
		loadMore() {
		        console.log('loadMore');
				setTimeout(()=>{
					for(let i=0;i<=10;i++){
						
						this.list.push(i);
					}
					
					this.$refs.loadRefresh.loadOver();
					this.currPage+=1;
				},5000);
				
				this.totalPage=6;
		        // 请求新数据完成后调用 组件内loadOver()方法
		        // 注意更新当前页码 currPage
		      },
		      // 下拉刷新数据列表
		      refresh() {
		        console.log('refresh');
		      },
		animationClick(){
			console.log(1);
			if(!this.state){
			this.animation.translateY(-90).opacity(0).step({
				duration:600
			});
			// 导出动画数据传递给data层
			this.animationData = this.animation.export();
			setTimeout(()=>{
				this.animation.translateY(0).opacity(1).step({
					duration:500
				});
				this.animationData2=this.animation.export();
			},700);
			}else{
				this.animation.translateY(0).opacity(1).step();
				this.animationData = this.animation.export();
			}
			this.state=!this.state;
		}
	}
};
</script>

<style lang="less" scoped>
.test{
	position: relative;
	// height:2000upx;
	// background:#000;
}
.list{
	overflow: hidden;
	li{
		width: 100%;
		height:100px;background:blue
	}
}
.contain{
	width:50px;height:50px;
	margin:100px auto;
	background:blue;
}
body {
	overflow-x: hidden;
}

canvas {
	background: transparent;
  position: absolute;
  display: block;
  height: 100vh;
  width: 100%;
  z-index: 2;
}
.yellow{
	width:200px;
	height:200px;
	background:yellow;
	position: absolute;
	transform: translateY(-100%);
	opacity: 0;
}
.hero {
	display: flex;
	justify-content: center;
	align-items: center;
  position: relative;
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  background:#000;
  background-image: url(https://lishiots.oss-cn-hangzhou.aliyuncs.com/webstatic/blue.png);
  background-position: center center;
  background-size: cover;
  z-index: 1;
	
	.text {
		text-align: center;
		color: #fff;
	}
	
	h1 {
		font-size: 48px;
		margin-bottom: 10px;
	}
}
</style>
